import { useEffect, useState } from "react";
import { Loader2, Zap } from "lucide-react";
import { api, errMsg, imgUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

export function useBoyInfo(code) {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/public/boy/${code}`).then((r) => setInfo(r.data)).catch((e) => setErr(errMsg(e)));
  }, [code]);
  return [info, err];
}

export function BoyShell({ info, wide, children }) {
  return (
    <div className="grain min-h-screen px-4 py-8 sm:py-12">
      <div className={cn("fade-up mx-auto space-y-6", wide ? "max-w-3xl" : "max-w-md")}>
        <header className="flex items-center gap-3" data-testid="boy-shell-header">
          {info?.logo_url
            ? <img src={imgUrl(info.logo_url)} alt="" className="h-12 w-12 rounded-xl border object-cover" />
            : <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground"><Zap className="h-6 w-6" /></span>}
          <div className="min-w-0">
            <p className="eyebrow">Boy Express</p>
            <p className="truncate text-xl font-bold" data-testid="boy-store-name">{info?.store}</p>
          </div>
        </header>
        {children}
      </div>
    </div>
  );
}

export function BoyGate({ info, err, wide, children }) {
  if (err) return <BoyShell><p className="card-surface p-6 text-center text-sm text-muted-foreground" data-testid="boy-error">{err}</p></BoyShell>;
  if (!info) return <BoyShell><p className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin" /></p></BoyShell>;
  return <BoyShell info={info} wide={wide}>{children}</BoyShell>;
}
